import { conditionOperators } from "Forms/FormElementTypes"

export const makeFlagCondition = (questionType) => {
  const operators = conditionOperators({ questionType })

  return { operator: operators[0], matchValue: null }
}
